import moment from 'moment';
import { convertDateToDash } from '@/helpers/format.js';
import { countries } from 'countries-list';

export function checkDate(value) {
  if (!value) {
    return true;
  }

  if (!value.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
    return false;
  }

  return moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY') === value;
}

export function hasValue(value) {
  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  return value.trim().length > 0;
}

export function civility(civility) {
  if (!hasValue(civility)) {
    return true;
  }

  return ['m', 'f'].includes(civility);
}

export function professionalType(professionalType) {
  if (!hasValue(professionalType)) {
    return true;
  }

  return [
    'doctor',
    'paramedical',
    'therapist',
    'secretary',
    'nurse'
  ].includes(professionalType);
}

export function over16YearsOld(birthDate) {
  if (!hasValue(birthDate)) {
    return true;
  }

  return moment().diff(convertDateToDash(birthDate), 'years') >= 16;
}

export function country(countryCode) {
  if (!hasValue(countryCode)) {
    return true;
  }

  return !!countries[countryCode]
}
